<template>
  <div class="justification-picker dropdown" :class="{ active, 'dropdown-right': true }"
       v-click-outside="closeMenu">
    <button class="btn btn-sm btn-gray btn-icon btn-icon-left" :disabled="disabled"
            @click="toggle">
      <fa-icon :icon="['fal', 'books']"/>Usar justificativa salva
      <span class="bg-count ml-1" v-if="items.length">{{ items.length }}</span>
    </button>
    <div class="menu bg-jp-menu" v-if="active">
      <input type="text" class="form-input input-sm bg-jp-search" v-model="search"
             :placeholder="`Buscar nas salvas para ${code}`" ref="search">
      <div class="loading" v-if="loading"></div>
      <div class="bg-jp-empty text-gray text-xs" v-else-if="filtered.length === 0">
        Nenhuma justificativa salva para o código
        {{ code }}. Marque "Salvar esta justificativa" ao escrever uma.
      </div>
      <div class="bg-jp-item" v-for="item in filtered" :key="item.id" @click="select(item)">
        <b>{{ item.title }}</b>
        <p>{{ item.text }}</p>
        <small>
          usada {{ item.usageCount || 0 }}×
          <template v-if="item.lastUsedAt"> · última {{ item.lastUsedAt | date }}</template>
        </small>
        <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left bg-jp-remove"
                data-tooltip="Excluir da biblioteca" :disabled="!canManage"
                @click.stop="remove(item)">
          <fa-icon :icon="['fal', 'trash']"/>
        </button>
      </div>
      <div class="bg-jp-foot text-xs text-gray">
        Variáveis: {{ variables }}
      </div>
    </div>
  </div>
</template>

<script>
import { MANAGE_BILLING_GLOSSES } from '@/data/actions/modules/financial';
import { fillTemplate } from '../helpers';

const VARIABLES = ['paciente', 'guia', 'procedimento', 'senha', 'data'];

export default {
  props: {
    code: {
      type: String,
      required: true,
    },
    context: {
      type: Object,
      default: () => ({}),
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: false,
      search: '',
    };
  },
  computed: {
    canManage() {
      return this.$can(MANAGE_BILLING_GLOSSES);
    },
    variables() {
      return VARIABLES.map(name => `{{${name}}}`).join(' ');
    },
    filtered() {
      const term = this.search.trim().toLowerCase();
      if (!term) return this.items;
      return this.items.filter(item => `${item.title} ${item.text}`.toLowerCase().includes(term));
    },
  },
  methods: {
    toggle() {
      this.active = !this.active;
      if (this.active) {
        this.$emit('open');
        this.$nextTick(() => {
          if (this.$refs.search) this.$refs.search.focus();
        });
      }
    },
    closeMenu() {
      this.active = false;
    },
    select(item) {
      this.$emit('select', {
        id: item.id,
        text: fillTemplate(item.text, this.context),
      });
      this.active = false;
    },
    remove(item) {
      this.$emit('remove', item);
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";

.justification-picker {
  display: inline-block;
  position: relative;
  .bg-jp-menu {
    display: block;
    left: auto;
    max-height: 22rem;
    overflow-y: auto;
    padding: $layout-spacing-sm;
    right: 0;
    width: 22rem;
    z-index: 20;
  }
  .bg-jp-search { margin-bottom: $layout-spacing-sm; }
  .bg-jp-empty { padding: $layout-spacing-sm; }
  .bg-jp-item {
    border-radius: $border-radius;
    cursor: pointer;
    padding: $layout-spacing-sm;
    position: relative;
    &:hover { background-color: $gray-color-ultra-light; }
    b { display: block; font-size: $font-size-sm; padding-right: 1.4rem; }
    p {
      color: $gray-color-dark;
      font-size: $font-size-xs;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    small { color: $gray-color; font-size: .5rem; }
    .bg-jp-remove { position: absolute; right: .2rem; top: .2rem; }
  }
  .bg-jp-foot {
    border-top: $border-color solid $border-width;
    margin-top: $layout-spacing-sm;
    padding: $layout-spacing-sm $layout-spacing-sm 0;
  }
}
</style>
